import type { ReactNode } from 'react';
import { Progress } from './Progress';

/** Шаги знакомства: экран «что это + твой модуль», тренировка, итог. */
export const ONBOARDING_STEP_COUNT = 3;

interface OnboardingShellProps {
  /** Индекс шага: 0 — экран модуля, 2 — итог (тренировка рисует свой экран). */
  step: number;
  children: ReactNode;
}

/**
 * Полноэкранный каркас шага: своя прокрутка (`h-dvh overflow-y-auto`, у body прокрутки нет),
 * колонка до 560px по центру экрана, поля 16px на телефоне — без прокрутки вбок.
 */
export function OnboardingShell({ step, children }: OnboardingShellProps) {
  return (
    <div className="flex h-dvh flex-col overflow-y-auto overflow-x-hidden bg-base">
      <div className="mx-auto my-auto flex w-full max-w-[560px] animate-fadeIn flex-col px-4 py-8 sm:px-6 nav:py-12">
        <Progress total={ONBOARDING_STEP_COUNT} current={step} />
        {children}
      </div>
    </div>
  );
}

/** Спиннер внутри основной кнопки на время запроса. */
export function ButtonSpinner() {
  return (
    <span
      aria-hidden
      className="block h-4 w-4 flex-none animate-spin rounded-full border-2 border-fg-inv/30 border-t-fg-inv"
    />
  );
}
